
import Vue from 'vue';
import moment from 'moment';
import Card from '@/components/Card/index.vue';
import Footer from '@/components/Footer/index.vue';
import HeaderInternal from '@/components/HeaderInternal/index.vue';
import Modal from '@/components/Modal/index.vue';
import Tag from '@/components/Tag/index.vue';
import getTerritoryByCarCodeService from '@/services/territory/get-territory-by-car-code';
import getTerritoryByIdService from '@/services/territory/get-territory-by-id';
import { deleteMonitoring } from '@/services/territory-access/delete';
import { getUserGroup, isDocumentACP } from '@/utils';
import Accordion from '@/components/Accordion/index.vue';
import { StatusTerritoryAccess } from '@/config/types';
import { actPdfCreate, ActPdfParams } from '@/services/act/get-link-document-act';
import getActData from '@/services/act/get-act';
import { ActCurrentParams, getActCurrentByCdTerritory } from '@/services/act/get-act-current-by-cd-territory';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
import { getLinkTermCommitmentbyCdAgentCarNumber } from '@/services/term-commitment/get-document-by-cd-agent-car-number';
import { getReport, GetReportParms } from '@/services/territory/get-report';
// import { getAgentByDocument } from '@/services/agent/get-agent-by-document';
import {
  Container, Main, Wrapper, ContentDocs,
} from './styles';

Vue.prototype.StatusTerritoryAccess = StatusTerritoryAccess;

export default Vue.extend({
  components: {
    Card,
    Container,
    Footer,
    HeaderInternal,
    ContentDocs,
    Main,
    Modal,
    Tag,
    Accordion,
    Wrapper,
  },
  data() {
    return {
      modalButtons: [
        {
          click: 'close',
          title: 'Não, cancelar',
          type: 'secondary',
        },
        {
          click: 'cancelMonitoring',
          title: 'Sim, deixar de monitorar',
          type: 'error',
        },
      ],
      modalErrorButtons: [
        {
          click: 'close',
          title: 'Fechar',
          type: 'secondary',
        },
      ],
      modalDescription:
        'Ao confirmar, você deixará de visualizar as informações da Fazenda Esperança. Para voltar a monitorar essa fazenda será necessário solicitar acesso novamente.',
      modalErrorDescription:
        'Ocorreu um erro ao deixar de seguir esse território, por favor tente novamente e caso o erro persista, contate o administrador do sistema.',
      modalSuccessDescription: 'Sucesso ao realizar a solicitação',
      showConfirmModal: false,
      showErrorModal: false,
      showSuccessModal: false,
      territory: {
        agents: [],
        city: '',
        documents: [],
        loaded: false,
        name: '',
      } as any,
      territoryByCar: {
        aderiuPRA: '',
        area: '',
        condicaoAnalise: '',
        dataAnalise: '',
        dataRegistro: '',
        dataRetificacao: '',
        latitude: '',
        loaded: false,
        longitude: '',
        modulosFiscais: '',
        statusImovel: '',
        estado: '',
      },
      nameTerritory: '',
      territoryData: {
        frigId: 0,
        territoryId: 0,
        TokenKey: '',
      },
      hiddenButton: false,
      actArray: [] as any[],
      headerColumnsAct: ['Nome', 'Data de Inicio', 'Fim do prazo', 'Status', 'PDF'],
      headerColumnsDocs: ['Nome', 'PDF'],
      linkActPdf: '',
      actCurrent: {},
      termSocioEnvironmental: {
        type: 'termSocioEnvironmental',
      } as any,
      docsLink: [] as any[],
      termCommitment: '',
      actLoaded: false,
    };
  },
  computed: {
    showButton(): boolean {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      return this.territory.territoryAccess !== StatusTerritoryAccess.denied && !this.hiddenButton;
    },
  },
  methods: {
    async cancelMonitoring() {
      const response = await deleteMonitoring({
        frigId: this.territoryData.frigId,
        territoryId: this.territoryData.territoryId,
        TokenKey: this.territoryData.TokenKey,
      });

      if (response.hasErrors) {
        this.showConfirmModal = false;
        this.showErrorModal = true;
        return;
      }

      this.showConfirmModal = false;
      this.showSuccessModal = true;
    },
    closeSuccessModal() {
      this.showSuccessModal = false;
      this.$router.replace(`/${getUserGroup()}`);
    },
    removeRelation() {
      this.showConfirmModal = true;
    },
    async getTerritoryById() {
      const { id } = this.$route.params;
      const response = await getTerritoryByIdService(id);

      this.territory = response.objectResult;

      this.territory.loaded = true;

      this.getTerritoryByCarCode(this.territory.documents[0].title);
      const { idUser } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
      this.territoryData.frigId = idUser;
      this.territoryData.territoryId = response.objectResult.id;
      this.territoryData.TokenKey = 'nF3K9Vry9z3nNDwSYxxRKw==';
    },
    async getTerritoryByCarCode(carCode: string) {
      const { objectResult } = await getTerritoryByCarCodeService(carCode);

      this.territoryByCar = objectResult.dadosExtratoPdf;

      this.territoryByCar.loaded = true;
    },
    checkIsDocumentACP(type: number) {
      return isDocumentACP(type);
    },
    goToGeo(dataType: string, dataInitial: string, dataEnd: string) {
      if (dataType === 'ACT') {
        this.$router.push({ name: 'ACT', params: { dataStart: dataInitial, dataEnd } });
      }
    },
    async getAct() {
      const resp = await getActData(this.territoryData.TokenKey, this.territory.id);
      const reduced = [] as any;
      resp.objectResult.forEach((item: any) => {
        const duplicated = reduced.findIndex((redItem: any) => {
          return item?.act === redItem?.act;
        }) > -1;
        if (!duplicated) {
          reduced.push(item);
        }
      });
      if (resp.hasErrors === false) {
        this.actArray = reduced;
        this.actLoaded = true;
      }
    },
    convertDateActsArray() {
      for (let i = 0; i < this.actArray.length; i += 1) {
        // @ts-ignore
        this.actArray[i].act = moment(this.actArray[i].act).format('DD/MM/YYYY');
        // @ts-ignore
        this.actArray[i].dtAutovistory = moment(this.actArray[i].dtAutovistory).format('DD/MM/YYYY');
      }
    },
    async actCreatePdf(dataInitial: string, dataEnd: string) {
      const params: ActPdfParams = {
        tokenKey: this.territoryData.TokenKey,
        carNumber: this.territory.documents[0].title,
        cdAgent: this.territory.agents[0].id,
        validityDateACT: moment(dataEnd).format('DD/MM/YYYY'),
        issueDateACT: moment(dataInitial).format('DD/MM/YYYY'),
        territoryName: this.territory.name,
        city: this.territory.city,
        state: this.territoryByCar.estado,
      };
      const response = await actPdfCreate(params);

      window.open(response.objectResult, '_blank');
    },
    async getLinkActCurrent() {
      const params: ActCurrentParams = {
        tokenKey: this.territoryData.TokenKey,
        cdTerritory: this.territory.id,
      };
      await getActCurrentByCdTerritory(params).then((resp) => {
        this.actCurrent = resp.objectResult;
      });
      const paramsPdf: ActPdfParams = {
        tokenKey: this.territoryData.TokenKey,
        carNumber: this.territory.documents[0].title,
        cdAgent: this.territory.agents[0].id,
        // @ts-ignore
        validityDateACT: moment(this.actCurrent.act).format('DD/MM/YYYY'),
        // @ts-ignore
        issueDateACT: moment(this.actCurrent.dtAutovistory).format('DD/MM/YYYY'),
        territoryName: this.territory.name,
        city: this.territory.city,
        state: this.territoryByCar.estado,
      };
      const response = await actPdfCreate(paramsPdf);
      this.linkActPdf = response.objectResult;
    },
    async getLinkDocumentTermCommitment() {
      const response = await getLinkTermCommitmentbyCdAgentCarNumber(
        this.territoryData.TokenKey, this.territory.agents[0].id, this.territory.documents[0].title,
      );
      if (response.objectResult !== null) {
        this.termCommitment = response.objectResult;
      } else {
        this.termCommitment = 'null';
      }
    },
    openDocumentPdf(url: string) {
      window.open(url, '_blank');
    },
    async getReportRequest() {
      // const agentResponse = await getAgentByDocument(this.territoryData.TokenKey, this.territory.agents[0].document);

      const params: GetReportParms = {
        // @ts-ignore
        cdUser: this.territoryData.frigId,
        tokenKey: this.territoryData.TokenKey,
        cdTerritory: this.territory.id,
      };
      await getReport(params).then((data) => { this.termSocioEnvironmental = { ...this.termSocioEnvironmental, ...data }; });
    },
    updateStatusAct() {
      const dataValidityActCurrent = moment(this.territory.actCurrent.act).format('DD/MM/YYYY');
      for (let i = 0; i < this.actArray.length; i += 1) {
        // @ts-ignore
        if (this.actArray[i].act && this.actArray[i].act === dataValidityActCurrent) {
          // @ts-ignore
          this.actArray[i].status = 'ativo';
        }
      }
    },
  },
  async created() {
    await this.getTerritoryById();
    await this.getAct();
    this.getLinkDocumentTermCommitment();
    this.getLinkActCurrent();
    await this.getReportRequest();
  },
});
